/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgElectricOff = (props: Props) => (
  <Icon viewBox="0 0 24 25" {...props}>
    <g fill="none">
      <path
        d="m14.156 16.22 7.137 7.137 1.414-1.414-6.215-6.215.013-.006-1.585-1.584-.015.003-4.718-4.719.003-.015-1.585-1.585-.005.013-5.893-5.892-1.414 1.414 6.814 6.814a5.986 5.986 0 0 0 1.109 3.527l-.994.994-6.547-2.806 3.48 8.7L3.5 22.243l1.414 1.414 2.588-2.588-2.177-5.441 3.353 1.437 1.952-1.952a5.985 5.985 0 0 0 3.526 1.109zm4.194-1.757a6.117 6.117 0 0 1-.14.136l-1.416-1.416c.048-.043.095-.088.141-.134l1.414-1.414-5.656-5.657-1.415 1.414c-.046.046-.09.093-.134.141L9.73 6.118l.135-.14 2.829-2.828 1.414 1.414 2.121-2.121 1.414 1.414-2.121 2.121 2.828 2.828 2.122-2.12 1.414 1.413-2.122 2.122 1.415 1.414-2.829 2.828z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgElectricOff as ElectricOff };
